<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
  
      <div class="flex-1 flex flex-col">
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md bg-gradient-to-b from-gray-800 to-gray-900 border-b border-gray-700">
          <h2 class="text-xl font-semibold">Firewall Rules</h2>
        </header>
  
        <main class="p-6 flex-1">
            <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
            rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold mb-4">Manage Firewall Rules</h3>
  
            <!-- Add New Rule -->
            <div class="mb-6 p-4 bg-gray-700 rounded">
              <h4 class="text-md font-semibold mb-3">Add New Rule</h4>
              <div class="grid grid-cols-4 gap-4">
                <select v-model="newRule.type" class="p-2 bg-gray-600 rounded">
                  <option value="TCP">TCP</option>
                  <option value="UDP">UDP</option>
                  <option value="ICMP">ICMP</option>
                </select>
  
                <input
                  v-model="newRule.port"
                  type="number"
                  min="1"
                  max="65535"
                  placeholder="Port"
                  class="p-2 bg-gray-600 rounded text-white"
                />
  
                <select v-model="newRule.action" class="p-2 bg-gray-600 rounded">
                  <option value="Allow">Allow</option>
                  <option value="Deny">Deny</option>
                </select>
  
                <button
                  @click="addRule"
                  class="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded"
                >
                  Add Rule
                </button>
              </div>
              <p v-if="validationError" class="text-red-500 mt-2 text-sm">{{ validationError }}</p>
            </div>
  
            <!-- Firewall Rules Table -->
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3">ID</th>
                  <th class="p-3">Type</th>
                  <th class="p-3">Port</th>
                  <th class="p-3">Action</th>
                  <th class="p-3">Manage</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rule in firewallRules" :key="rule.id" class="border-b border-gray-600">
                  <td class="p-3">{{ rule.id }}</td>
                  <td class="p-3">{{ rule.type }}</td>
                  <td class="p-3">{{ rule.port }}</td>
                  <td class="p-3">{{ rule.action }}</td>
                  <td class="p-3">
                    <button
                      class="px-3 py-1 bg-red-500 rounded hover:bg-red-600"
                      @click="deleteRule(rule.id)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/nav.vue';
  import axios from 'axios';
  
  export default {
    name: "FirewallPage",
    components: { Navbar },
    data() {
      return {
        firewallRules: [],
        newRule: { type: "TCP", port: "", action: "Allow" },
        validationError: ""
      };
    },
    mounted() {
      this.fetchFirewallRules();
    },
    methods: {
      async fetchFirewallRules() {
        const serverId = this.$route.params.id;
        try {
          const res = await axios.get(`https://api.syniac.com:3000/api/firewall/${serverId}`, { withCredentials: true });
          this.firewallRules = res.data;
        } catch (error) {
          console.error("Error fetching firewall rules:", error);
        }
      },
      validateRule() {
        if (!this.newRule.port || this.newRule.port < 1 || this.newRule.port > 65535) {
          this.validationError = "Port must be between 1 and 65535.";
          return false;
        }
        this.validationError = "";
        return true;
      },
      async addRule() {
        if (!this.validateRule()) return;
        const serverId = this.$route.params.id;
        try {
          const res = await axios.post(`https://api.syniac.com:3000/api/firewall/${serverId}`, this.newRule, { withCredentials: true });
          this.firewallRules.push(res.data);
          this.newRule = { type: "TCP", port: "", action: "Allow" };
        } catch (error) {
          console.error("Error adding firewall rule:", error);
        }
      },
      async deleteRule(id) {
        if (!confirm("Delete this rule?")) return;
        try {
          await axios.delete(`https://api.syniac.com:3000/api/firewall/${id}`, { withCredentials: true });
          this.firewallRules = this.firewallRules.filter(r => r.id !== id);
        } catch (error) {
          console.error("Error deleting firewall rule:", error);
        }
      }
    }
  };
  </script>
  
